import React             from "react"
import { ResponsivePie } from '@nivo/pie'
import { EmptyCard }     from "./EmptyCard"
import { parseMoney } from "../../../application/helpers/helpers"

export const TopTypes = ({ data, types, type, currency }) => {
  const STATUS_HEIGHT     = 600
  if (!data?.props_top_types) return

  const title = types.find(typ => typ[1] == type)[0]

  return (
    <div className="dashboard__card mr-3 w-92vw">
      <h3>{I18n.t(`dashboard.percentage_by`, {type: title.toLowerCase()})}</h3>
        {
          !data.props_top_types.length ? <EmptyCard />
          :
          <div style={{ height: `${STATUS_HEIGHT}px` }}>
            <ResponsivePie
              data                             = {data.props_top_types}
              margin                           = {{ top: 20, bottom: 20 }}
              innerRadius                      = {0.5}
              padAngle                         = {0.7}
              cornerRadius                     = {3}
              borderWidth                      = {1}
              sliceLabel                       = {({ value }) => `${parseMoney(value, currency, { round: true })}`}
              radialLabel                      = {d => d.label}
              radialLabelsSkipAngle            = {10}
              radialLabelsTextXOffset          = {6}
              radialLabelsTextColor            = "#333333"
              radialLabelsLinkDiagonalLength   = {16}
              radialLabelsLinkHorizontalLength = {24}
              radialLabelsLinkStrokeWidth      = {1}
              radialLabelsLinkColor            = {{ from: 'color' }}
              slicesLabel                      = {d => d.label}
              slicesLabelsSkipAngle            = {10}
              slicesLabelsTextColor            = "#333333"
              startAngle                       = {0}
              animate
              motionStiffness                  = {90}
              motionDamping                    = {15}
              tooltip = {({ datum: { id, value } }) => (
                <div style={{ background: 'white', 'whiteSpace': 'nowrap' }}>
                  {id} : {parseMoney(value, currency)}
                </div>
              )}

            />
          </div>
        }
    </div>
  )
}
